import { render, staticRenderFns } from "./DeleteNotification.vue?vue&type=template&id=eb7cba72&scoped=true"
import script from "./DeleteNotification.vue?vue&type=script&lang=js"
export * from "./DeleteNotification.vue?vue&type=script&lang=js"
import style0 from "./DeleteNotification.vue?vue&type=style&index=0&id=eb7cba72&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb7cba72",
  null
  
)

export default component.exports